import { render, staticRenderFns } from "./novel_list.vue?vue&type=template&id=555ea4c8&scoped=true"
import script from "./novel_list.vue?vue&type=script&lang=js"
export * from "./novel_list.vue?vue&type=script&lang=js"
import style0 from "./novel_list.vue?vue&type=style&index=0&id=555ea4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ea4c8",
  null
  
)

export default component.exports